import { Perceptron } from "./perceptron.js"
import { activationFunctions } from "./activation.js"
import { getId } from "./id.js"
import { RNG } from "./rng.js"

class Layer {
  constructor(size, nInputs, params) {
    this.nInputs = nInputs // number of outputs from previous layer
    this.size = size // number of perceptrons

    var defaults = {
      activation: activationFunctions.sigmoid,
      seed: 42,
      perceptrons: null
    }
    params = {...defaults, ...params}

    this.id = getId()

    this.perceptrons = []
    var r = new RNG(params.seed)

    // add perceptrons to layer
    if(params.perceptrons) {
      this.perceptrons = params.perceptrons
    }
    else {
      for(let i = 0; i < size; i++) {
        // initialize weight using He method
        var std = Math.sqrt(2/nInputs)
        var weights = []
        for(let j = 0; j < nInputs; j++) {
          weights.push(r.randGaussian(std))
        }

        this.perceptrons.push(new Perceptron(weights, {activation: params.activation}))
      }
    }
  }

  // load layer from object
  static load(data) {
    return new Layer(data.size, data.nInputs, {
      perceptrons: data.perceptrons.map(p => Perceptron.load(p))
    })
  }

  // export to serializable object
  dump() {
    return {
      nInputs: this.nInputs,
      size: this.size,
      perceptrons: this.perceptrons.map(p => p.dump())
    }
  }

  // iterate over perceptrons
  iterate(f) {
    for(perceptron in this.perceptrons) {
      f(perceptron)
    }
  }

  // derivative of RMSE cost function
  cost_derivative(output, y) {
    cost_derivatives = []
    for(let i=0; i++; i < length(output)) {
      cost_derivatives.push(a)
    }
  }

  evaluate(inputs, params) {
    const defaults = {
      verbose: false
    }
    params = {...defaults, ...params}

     if(inputs.length != this.nInputs) {
      throw new Error(`Input size mismatch: expected ${this.nInputs} got ${inputs.length}`)
    }

    var outputs = []

    // iterate through perceptrons
    for(let i = 0; i < this.size; i++) {
      var p = this.perceptrons[i]

      // evaluate each perceptron with inputs
      var output = p.evaluate(inputs, {verbose: params.verbose})

      // add activation from each perceptron to output
      outputs.push(output)
    }

    return outputs
  }
}

export {
  Layer
}